<!--The content below is only a placeholder and can be replaced.-->
<router-outlet></router-outlet>
<app-footer></app-footer>
<app-relogin></app-relogin>
